import * as React from "react";
import { Footer } from "bernie-global-components";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

/**
 * Represents the component at the bottom of a Blossom page. It will either use
 * an HTML string (parsed to add UITK styles) from globalcontrols on mobile or the Bernie
 * footer if it is on desktop HTG/F pages
 */
export const FlexFooter = ({
  footer,
  context,
  isMobile
}: {
  // Footer could come as a HTML string or JSON object
  footer: string | object;
  context: ExtendedContextStore;
  isMobile: boolean;
}) => {
  const pageType = context.searchContext.pageType;

  // Use the bernie footer for desktop HTG/F pages, or as a fallback for other pages.
  // For desktop HTG/F pages, SWXL links are into their own modules.
  const shouldUseBernieFooter =
    (!isMobile &&
      (pageType === "Travel-Guide-Hotels" ||
        pageType === "Travel-Guide-Filter-Hotels" ||
        pageType === "Travel-Guide-Accommodation")) ||
    !footer ||
    typeof footer === "object";

  if (shouldUseBernieFooter) {
    return (
      <div className="all-y-padding-three">
        <Footer context={context} />
      </div>
    );
  }

  return (
    <footer
      className="TripPlanning uitk-cell all-x-padding-three all-cell-1-1 footer"
      dangerouslySetInnerHTML={createMarkup(footer as string)} //Typescript doesn't understand the typeof check above.
    />
  );
};

/**
 * Replaces parts of a string footer HTML to add styling. Should eventually be
 * deprecated in favor of a Bernie footer.
 * @param footer - String representing an HTML markup from Flex to parse through
 */
function createMarkup(footer: string) {
  const footerWithStyle = footer
    ? footer
        .replace(/<h5/g, `<h5 class="uitk-type-heading-300"`)
        .replace(/class="flag/g, 'class="uitk-flag flag')
        // In UITK, the UK flag has a "gb" class so we have to change it
        .replace(/flag uk/g, "flag gb")
        // In Uitk the Indonesia flag has a "id" class so we have to change it
        .replace(/flag ind/g, "flag id")
    : footer;

  return { __html: footerWithStyle };
}
